<template>
  <div id="mp-left-menu">
    <div class="menus">
      <div class="menuTitle menuItemBorder">{{ menus[0].menu[0].text }}</div>
      <div
        v-for="(menu, index) in menus[1].menu"
        :key="index"
        :class="
          menus[1].active === menu.id
            ? index + 1 === menus[1].menu.length
              ? 'menuItemActive'
              : 'menuItemActive menuItemBorder'
            : index + 1 === menus[1].menu.length
            ? 'menuItem'
            : 'menuItem menuItemBorder'
        "
        @click="menus[1].active = menu.id"
        v-waves
      >
        {{ menu.text }}
      </div>
    </div>
  </div>
</template>

<script>
import Waves from "@/assets/js/waves.js";
export default {
  props: {
    menus: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  directives: { Waves }
};
</script>

<style lang="less" scoped>
#mp-left-menu {
  width: 185px;
  font-family: "微软雅黑";
  .menus {
    width: 100%;
    border: 1px solid #e8eaec;
    .menuTitle {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      font-size: 18px;
      padding: 10px 12px;
      font-weight: bold;
      color: #2b85e4;
    }
    .menuItem {
      min-width: 96px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding: 12px 12px;
      font-size: 16px;
      cursor: pointer;
    }
    .menuItem:hover {
      background: #f0faff;
    }
    .menuItemActive {
      min-width: 96px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding: 12px 12px;
      font-size: 16px;
      border-right: 4px solid #2b85e4;
      background: #f0faff;
      cursor: pointer;
    }
    .menuItemBorder {
      border-bottom: 1px solid #e8eaec;
    }
  }
}
</style>
